import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import * as OnTapActions from './actions'
import { IOnTapTvActiveDisplay } from 'app/models/ontapTvActiveDisplays';
import * as fromOnTapAdvanced from 'app/state/on_tap_advanced/reducer';

export interface State extends EntityState<IOnTapTvActiveDisplay> {
  // additional entity state properties
  selectedId: string | null;
  error: string;
}


export function sortByName(a: IOnTapTvActiveDisplay, b: IOnTapTvActiveDisplay): number {
  if (!a || !b) return 0;
  if (!a.deviceName && !b.deviceName) return 0;
  if (!a.deviceName) return -1;
  if (!b.deviceName) return 1;
  return a.deviceName.localeCompare(b.deviceName);
}
export function selectId(a: IOnTapTvActiveDisplay): string {
  return a.id ?? '';
}
export const adapter: EntityAdapter<IOnTapTvActiveDisplay> = createEntityAdapter<IOnTapTvActiveDisplay>({
  sortComparer: sortByName,
  selectId: selectId
});

export const initialState: State = adapter.getInitialState({
  selectedId: null,
  error: ''
});

export const stateName = 'ontapTvActiveDisplays';

export const reducer = createReducer<State>(
  initialState,
  on(OnTapActions.clearAllItems, (state) => {
    return adapter.removeAll(state);
  }),
  on(OnTapActions.loadItemsSuccess, (state, { items }) => {
    return adapter.setAll(items, state);
  })
);

// get the selectors
const { selectAll, selectEntities } = adapter.getSelectors();

// Export selectAll for effect caching
export { selectAll };

const onTapBasicState = createFeatureSelector<State>(stateName);
export const selectAllItems = createSelector(onTapBasicState, selectAll);
export const selectAllEntities = createSelector(onTapBasicState, selectEntities);
export const selectEntity = (id: string) => createSelector(selectAllEntities, entities => entities[id]);
export const selectAllItemsFromCurrentOnTap = createSelector(
  selectAllItems,
  fromOnTapAdvanced.selectCurrentId,
  (items, currentOnTapId) => items.filter(item => item.onTapTv2Id === currentOnTapId)
);
